import { pushTo } from '@app/core/routing';
import { useAvailableSocialExportSources } from '@app/modules/fragments/hooks/useAvailableSocialExportSources';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { useFragment } from '@app/modules/fragments/screens/view/hooks/useFragment';
import { isSamePlatformId } from '@app/modules/social-export/domain/is-same-platform-id';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { PublishPlatformBar } from '@app/modules/social-export/publish';

/**
 * Platform icon bar for fragments; navigates to the fragment upload screen for the chosen platform.
 */
export function SocialExportPublishDropdown() {
  const { fragment } = useFragment();
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(
    fragment.stationId,
  );
  const { hasAvailableSources } = useAvailableSocialExportSources({
    fragmentId: fragment.id,
    stationId: fragment.stationId,
  });

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find((p) => isSamePlatformId(p.id, platformId));
    if (platform) {
      pushTo(routeGenerator.upload(fragment, platform));
    }
  };

  return (
    <PublishPlatformBar
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
